import Typography from '@mui/material/Typography';
import type { ReactNode } from 'react';

export function SectionLabel({ children }: { children: ReactNode }) {
  return (
    <Typography
      variant="caption"
      sx={{
        fontWeight: 700,
        color: 'text.disabled',
        textTransform: 'uppercase',
        letterSpacing: 0.6,
      }}
    >
      {children}
    </Typography>
  );
}
